import { Component, Input } from '@angular/core';
import { SummaryCard } from 'projects/store/src/app/interfaces';

@Component({
  selector: 'app-closing-report-summary-cards',
  templateUrl: './closing-report-summary-cards.component.html',
  styleUrls: ['./closing-report-summary-cards.component.scss']
})
export class ClosingReportSummaryCardsComponent {
  @Input() summaryCards: SummaryCard[] = [];
}
